// extracted by mini-css-extract-plugin
module.exports = {"prices_and_plans_banner":"PricesAndPlans_prices_and_plans_banner__4NYYs"};